import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface FormCheckboxProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

export function FormCheckbox({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  required = false,
  className,
}: FormCheckboxProps) {
  return (
    <div className={cn("flex items-center space-x-2", className)}>
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(val) => onChange(!!val)}
        disabled={disabled}
      />
      <Label
        htmlFor={id}
        required={required} // Usa a lógica do nosso Label customizado para o asterisco vermelho
        className={cn(
          // Adiciona cursor pointer para facilitar o clique no texto
          !disabled && "cursor-pointer",
          // Garante alinhamento e cor correta no Dark Mode
          "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        )}
      >
        {label}
      </Label>
    </div>
  );
}
